import { useQuery } from "react-query";
import { getDataEmployDealerLevel } from "~/pages/Employee/request/getDataEmployDealerLevel";

export default function useGetStaffDataEmployeDealerLevel(params: string) {
  return useQuery({
    queryKey: ["getDataEmployDealerLevel", params],
    queryFn: () => getDataEmployDealerLevel(params),
    refetchOnWindowFocus: false,
    // enabled,
    cacheTime: 0,
  });
}
